<template>
  <div id="knowledge-base-page">
    <div class="knowledge-base-jumbotron">
      <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white"><feather-icon icon="KeyIcon" class="w-5 h-5 mr-1"></feather-icon>eFactura</h1>
        <p class="text-white">This software section is securely protected with strong encryption, ensuring your data is
          safe.</p>
      </div>
    </div>
    <vx-card>
      <vs-alert color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mb-4">
        <strong>Use Microsoft Edge.</strong> The connection to ANAF (logincert.anaf.ro) requires your qualified
        certificate: Edge presents it automatically and the login works on the first try.
        With Chrome, Firefox or Safari the certificate is often not offered and the connection fails
        (&laquo; Please check your certificate &raquo;).
        <br />
        If you are not on Edge, copy this address into Edge:
        <strong>https://xylo.codesinn.com/web/efacturalogin</strong>
      </vs-alert>

      {{ message }}
    </vx-card>
  </div>
</template> 

<script>
import moduleBankList from "@/store/bank/moduleDataList.js";
import { Row } from "jspdf-autotable";
import moment from 'moment'

export default {
  data() {
    return {
      knowledgeBaseSearchQuery: '',
      connectAnaf: {},
      message: "Starting..."
    }
  },
  computed: {
    filteredKB() {
      return this.kb.filter((item) => item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()) || item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()))
    }
  },
  methods: {
    format_date(value, withhour) {
      if (value) {
        if (withhour) return moment(String(value)).format('DD MMM YYYY HH:mm:ss')
        else return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    daysUntilExpiration(expirationDate) {
      const expiry = moment(expirationDate);
      const today = moment();
      return expiry.diff(today, 'days');
    },
    async connectWithAnaf() {
      const clientId = '733aaeb80d694ddd760afd6ede7e2edd0c58d20fb6603d68';
      const redirectUri = encodeURIComponent('https://xylo.codesinn.com/web/anafcallback');
      const authUrl = `https://logincert.anaf.ro/anaf-oauth2/v1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&token_content_type=jwt`;
      window.location.href = authUrl;
    },
    handleButtonClick(event, path) {
      if (event.ctrlKey || event.metaKey) {
        window.open(path, '_blank');
      } else {
        this.$router.push(path);
      }
    },
    getTokenInfo() {
      this.$store
        .dispatch("BankList/getTokenInfo")
        .then(res => {
          this.token = res.data;
          try {
            if (this.token.toLowerCase().includes('error')) {
              this.message = 'Initiating connection with ANAF in 3 seconds... Your QUALIFIED CERTIFICATE is mandatory!'
              setTimeout(() => {
                try { this.connectWithAnaf() } catch (error) { this.message = "Error loading ANAF " + error }
              }, 3000);
            }
            else if (this.token.toLowerCase().includes('expired')) {
              this.message = 'Initiating connection with ANAF in 3 seconds... Your QUALIFIED CERTIFICATE is mandatory!'
              setTimeout(() => {
                try { this.connectWithAnaf() } catch (error) { this.message = "Error loading ANAF " + error }
              }, 3000);
            }
            else {
              this.message = 'Status: The token is active until ' + this.format_date(res.data.date, true) + ' (' + this.daysUntilExpiration(this.format_date(res.data.date), false) + ')'
            }
          } catch (error) {
            this.message = 'Status: The token is active until ' + this.format_date(res.data.date, true) + ' (' + this.daysUntilExpiration(this.format_date(res.data.date), false) + ' days)'

          }
        })
        .catch(err => {
          console.error(err);
          return false
        });
    },
  },
  async created() {
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule("BankList", moduleBankList);
      moduleBankList.isRegistered = true;
    }
    try{
    this.getTokenInfo()
    } catch (error) {
      console.error("Error in component created hook:", error);
    }
  },
  components: {}
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
  background-size: cover;
  height: 250px;
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}
</style>
